import {Ref} from "vue";
import {FormValidation} from "@km/mixins/formValidation";

export type ContactFormData = {
    vorname: Ref<string>,
    nachname: Ref<string>,
    street: Ref<string>,
    plz: Ref<string>,
    ort: Ref<string>,
    land: Ref<string>,
    email: Ref<string>,
    acceptprivacyterms: Ref<boolean>,
    anfrage: Ref<string>
}
export function getContactFormErrors(formData:ContactFormData) {
    return FormValidation.validate(
        {"email": formData.email},
        {"vorname": formData.vorname,"nachname": formData.nachname,"anfrage": formData.anfrage},
        {"acceptprivacyterms": formData.acceptprivacyterms}
    );
}


export function getAnfrageData(parameters: ContactFormData, store, lang) {
    return {
        typ: "Kontaktanfrage",
        category: "Kontaktanfrage",
        description: parameters.anfrage,
        contactEmail: parameters.email,
        saveID: -1,
        login: store.getters.getLoginname,
        ansprechpartner: parameters.vorname + " " + parameters.nachname,
        iso: lang,
        infoFromGetParameters: JSON.stringify(store.getters.getInfoFromGetParameters)
    };
}